import { render, staticRenderFns } from "./PanelStatusCard.vue?vue&type=template&id=7c21f620&scoped=true&"
import script from "./PanelStatusCard.vue?vue&type=script&lang=ts&"
export * from "./PanelStatusCard.vue?vue&type=script&lang=ts&"
import style0 from "./PanelStatusCard.vue?vue&type=style&index=0&id=7c21f620&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c21f620",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VRow,VSpacer})
